/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  IconChevronLeft,
  IconDownload,
  IconEye,
  IconPlus,
} from "@tabler/icons-react";
import ListView from "../../components/common/ListView";
import { useNavigate, useParams } from "react-router-dom";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import DropdownFilter from "../../components/common/DropdownFilter";
import NormalSearch from "../../components/common/NormalSearch";
import { useFetchShipmentsViewData } from "../../apis/pickupApis";
import { useEffect, useState } from "react";
import useDebounce from "../../utilities/useDebounce";
import toast from "react-hot-toast";
import Pagination from "../../components/common/Pagination";
import formatDate, { formatDateTime } from "../../utilities/helper";

export default function ViewShipmentDetails() {
  const navigate = useNavigate();
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1); // ✅ new state
  const { id } = useParams();
  const { data: shipmentDetails, refetch: shipmentsRefetch } =
    useFetchShipmentsViewData(id, pageNo, 10, searchFor);

  const shipmentDetailsData =
    shipmentDetails?.pickupRequests?.[0]?.shipments ?? [];

  const debouncedSearchFor = useDebounce(searchFor, 550);
  useEffect(() => {
    shipmentsRefetch(); // Trigger on search or page change
  }, [debouncedSearchFor]);

  const handlePaginationFetch = async (page: number) => {
    setPageNo(page);
    try {
      await shipmentsRefetch();
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    }
  };

  return (
    <div className="p-4 pt-0 space-y-4">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
          >
            <IconChevronLeft strokeWidth={1.5} size={22} />
          </button>
          <h1 className="text-xl font-medium text-[#212121]  ">
            Pickup ID : {id}
          </h1>
        </div>
      </div>

      <div>
        <div className="flex items-center">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
            <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
              Shipments ({shipmentDetails?.shipmentsCount})
            </h1>
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1); // Reset to page 1 on search
                }}
              />
            </div>
          </div>
          <div className="relative ml-5">
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>

        <div className="bg-[#F7F6F2]  rounded-tl-none rounded-3xl">
          {" "}
          <ListView
            data={shipmentDetails?.tatalShipments ?? []}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "#", render: (_, i) => i + 1 },
              {
                label: "Date",
                render: (c) => formatDateTime(c.createdAt) || "",
              },
              {
                label: "Referencer",
                render: (c) => c.referenceNumber || "",
              },
              { label: "AWB", render: (c) => c.awbNumber || "" },

              {
                label: "Forward Through",
                render: (c) => c.forwardThrough || "",
              },
              // {
              //   label: "Airway Bill No",
              //   render: (c) => c.airwayBillNo || "",
              // },
              {
                label: "City",
                render: (c) => c.city || "",
              },
              {
                label: "Actions",
                render: (c: any) => (
                  <div className="flex justify-center">
                    <button className="p-2 border rounded-full bg-[#F7F6F2]">
                      <IconEye size={22} />
                    </button>
                  </div>
                ),
              },
            ]}
          />
        </div>
        {shipmentDetails?.totalPages > 1 && (
          <Pagination
            totalPages={shipmentDetails?.totalPages}
            fetchData={handlePaginationFetch}
            currentPage={pageNo}
          />
        )}
      </div>
    </div>
  );
}
